import { render, staticRenderFns } from "./payment-icons.vue?vue&type=template&id=4ab13852&"
import script from "./payment-icons.vue?vue&type=script&lang=js&"
export * from "./payment-icons.vue?vue&type=script&lang=js&"
import style0 from "./payment-icons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab13852')) {
      api.createRecord('4ab13852', component.options)
    } else {
      api.reload('4ab13852', component.options)
    }
    module.hot.accept("./payment-icons.vue?vue&type=template&id=4ab13852&", function () {
      api.rerender('4ab13852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/payment/payment-methods-modal/payment-icons.vue"
export default component.exports